import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { object, func, array } from 'prop-types';
import { startSetSourcesList, startSetOffersSettings } from '@actions/app';
import { startRequestOfferAccess, startRefuseOfferAccess } from '@actions/webmaster';
import { startSetOfferInfo, startSetOfferFiles, resetOffer } from '@actions/offers';
import { setRedirectToPaymentsData } from '@actions/finances';
import { offersConstants } from '../../../constants/offers';

import AlertModal from '@modals/AlertModal/AlertModal';
import WithAlert from '@hoc/WithAlert';

import { FMessage } from '@hoc/IntlComponents';
import { OfferPageView } from '../index';
import { startSetStreamSettings, startCopyStream } from '../../../actions/streams';
import { prepareCopyFlow } from '../../flows/FlowsPage/FlowsPage';

class OfferPage extends Component {
  static propTypes = {
    offer: object.isRequired,
    countries: array.isRequired,
    currencies: array.isRequired,
    sources: array.isRequired,
    startSetOfferInfo: func.isRequired,
    startSetSourcesList: func.isRequired,
    startSetOffersSettings: func.isRequired,
    startSetOfferFiles: func.isRequired,
    startRequestOfferAccess: func.isRequired,
    startRefuseOfferAccess: func.isRequired,
    showAlert: func.isRequired,
  };

  static defaultProps = {
    offer: {},
    countries: [],
    currencies: [],
    sources: [],
  };

  constructor(props) {
    super(props);

    const { offer } = props;

    this.state = {
      loading: false,
      offerId: offer && offer.id ? offer.id : 0,
      confirmModal: false,
      errorModal: false,
      offerHasFlowsModalOpen: false,
      offerControlsModalToggle: false,
      error: {},
      isСopied: false,
    };
  }

  componentDidMount() {
    const { match, offerId, history } = this.props;
    let id;
    if (offerId) {
      id = offerId;
    } else {
      id = parseInt(match.params.id, 10);
    }
    this.props.startSetStreamSettings();
    this.props
      .startSetOffersSettings()
      .then(() => this.getOffer(id))
      .then(() => {
        if (this.props.offer.modifies.is_available === false) {
          history.replace('/offers');
        }
      });
  }

  componentWillUnmount() {
    this.props.resetOffer();
  }

  getOffer = (id) =>
    this.props
      .startSetOfferInfo(id)
      .then((response) => response.type)
      .then((type) => {
        if (type === offersConstants.SET_OFFER_FAILURE) {
          this.props.history.replace('/404');
        } else {
          this.setState(() => ({ offerId: id }));

          if (this.props.sources.length === 0) {
            this.props.startSetSourcesList();
          }

          this.props.startSetOfferFiles(id);
        }
      });

  handleRequestOfferAccess = (offerId) => {
    const { intl, history } = this.props;
    if (this.state.loading) {
      return;
    }

    this.setState(() => ({ loading: true }));

    this.props
      .startRequestOfferAccess(offerId)
      .then(() => this.getOffer(offerId))
      .then(() => this.setState(() => ({ loading: false })))
      .then(() => {
        this.props.showAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: intl.formatMessage(
            {
              id: 'offer.allowed-access.message',
              defaultMessage: `Access to «{offer}» is provided`,
            },
            { offer: this.props.offer.title },
          ),
        });
      })
      .catch(({ response }) => {
        console.log('error');
        if (response && response.data) {
          console.log('inner');
          const { message: error } = response.data.error;

          if (error.type && error.type === 'api.account.offer_request_ticket') {
            history.push(`/tickets/create?offer=${offerId}&theme=highLevelAccessRequest`);
          } else {
            console.log('modal');
            this.setState(() => ({
              errorModal: true,
              loading: false,
              offerId,
              error,
            }));
          }
        }
      });
  };

  handleRefuseOfferAccess = (offerId) => {
    this.setState(
      () => ({ offerId }),
      () => {
        this.toggleModal();
      },
    );
  };

  handleError = () => {
    this.setState(
      () => ({ errorModal: false }),
      () => {
        const { error, offerId } = this.state;
        const { history } = this.props;

        if (history) {
          switch (error.type) {
            case 'api.profile.phone.empty':
            case 'api.profile.phone.not_approved':
              history.push('/profile/edit');
              break;
            case 'api.account.offer_request_ticket':
              history.push(`/tickets/create?offer=${offerId}&theme=highLevelAccessRequest`);
              break;
            default:
              return false;
          }
        }
      },
    );
  };

  renderAlertModal = () => {
    const { setRedirectToPaymentsData } = this.props;
    const { error, errorModal } = this.state;
    if (error.message) {
      if (error.type === 'api.purses.empty') {
        return (
          <AlertModal
            open={errorModal}
            onClose={this.handleError}
            onSubmit={() => {
              setRedirectToPaymentsData({
                type: 1,
                pathname: '/profile/payment-data',
              });
            }}
          >
            <Fragment>
              <FMessage id="offers.error.no-wmz" />
              <FMessage id="offers.error.no-wmz.link.title" />
            </Fragment>
          </AlertModal>
        );
      } else {
        const indexTextLink = error.message.indexOf('[');
        const indexLinkHref = error.message.indexOf('(');
        const textMessages = error.message.slice(0, indexTextLink);
        const textLink = error.message.slice(indexTextLink + 1, indexLinkHref - 1);
        const linkHref = error.message.slice(indexLinkHref + 1, -1);

        return (
          <AlertModal open={errorModal} onClose={this.handleError}>
            {textMessages}
            <a href={linkHref} target="_blank">
              {textLink}
            </a>
          </AlertModal>
        );
      }
    }
    return null;
  };

  handleModal = () => {
    const { offerId: id } = this.state;
    this.toggleModal();
    this.props.startRefuseOfferAccess(id).then(() => this.getOffer(id));
  };

  toggleModal = () => {
    this.setState((prevState) => ({ confirmModal: !prevState.confirmModal }));
  };

  handleFlowCreate = (offerId) => {
    const {
      offer: { flows },
      history,
    } = this.props;
    if (flows && flows.length) {
      this.offerHasFlowsModalOpen();
    } else {
      history.push(`/tools/flows/create?offer=${offerId}`);
    }
  };

  offerHasFlowsModalToggle = () => {
    this.setState((prevState) => ({
      offerHasFlowsModalOpen: !prevState.offerHasFlowsModalOpen,
    }));
  };

  offerHasFlowsModalOpen = () => {
    this.setState(() => ({
      offerHasFlowsModalOpen: true,
    }));
  };

  offerControlsModalToggle = () => {
    this.setState((prevState) => ({
      offerControlsModalOpen: !prevState.offerControlsModalOpen,
    }));
  };

  offerControlsModalOpen = () => {
    this.setState(() => ({
      offerControlsModalOpen: true,
    }));
  };

  copyFlow = (flowId, offerId) => {
    const { startCopyStream, intl, base, startSetStreamSettings, startSetOfferInfo } = this.props;
    const newTitle = `${intl.formatMessage({
      id: 'flow.form.title.placeholder',
      defaultMessage: 'Flow',
    })} ${base.nextFlowIndex}`;
    this.setState({ isСopied: flowId }, () => {
      startCopyStream(flowId, newTitle, prepareCopyFlow)
        .then(() => startSetOfferInfo(offerId))
        .then(() => this.setState({ isСopied: null }))
        .then(() => startSetStreamSettings());
    });
  };

  render() {
    const { offer, currencies } = this.props;
    const [baseCurrency] = currencies;
    const topBundle = offer.top_bundle ? offer.top_bundle : {};

    const data = { ...this.props, ...this.state };

    return (
      <OfferPageView
        data={data}
        baseCurrency={baseCurrency}
        topBundle={topBundle}
        onRequestOfferAccess={this.handleRequestOfferAccess}
        onRefuseOfferAccess={this.handleRefuseOfferAccess}
        handleFlowCreate={this.handleFlowCreate}
        copyFlow={this.copyFlow}
        handleModal={this.handleModal}
        toggleModal={this.toggleModal}
        renderAlertModal={this.renderAlertModal}
        offerHasFlowsModalToggle={this.offerHasFlowsModalToggle}
        offerControlsModalToggle={this.offerControlsModalToggle}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { countries, sources, currencies } = state.app.globalSettings;
  const { profile } = state.webmaster;

  return {
    profile,
    countries,
    sources,
    currencies,
    offer: state.offers.selected,
    offerSettings: state.app.settings.offer,
    site_key: state.webmaster.profile.site_key,
    base: state.streams.settings.base,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startSetOffersSettings: () => dispatch(startSetOffersSettings()),
  startSetSourcesList: () => dispatch(startSetSourcesList()),
  startSetOfferInfo: (offerId) => dispatch(startSetOfferInfo(offerId)),
  startSetOfferFiles: (offerId) => dispatch(startSetOfferFiles(offerId)),
  startRequestOfferAccess: (offerId) => dispatch(startRequestOfferAccess(offerId)),
  startRefuseOfferAccess: (offerId) => dispatch(startRefuseOfferAccess(offerId)),
  resetOffer: () => dispatch(resetOffer()),
  setRedirectToPaymentsData: (data) => dispatch(setRedirectToPaymentsData(data)),
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  startCopyStream: (streamId, title, callback) =>
    dispatch(startCopyStream(streamId, title, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAlert(injectIntl(OfferPage)));
